const DELIVERY_METHODS = {
  EMAIL: 'email',
  SMS: 'sms',
}

export default DELIVERY_METHODS
